import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import InputSubmit from "../Input/InputSubmit";
import ThumbnailDropdownControl from "../InputControls/ThumbnailDropdownControl";
import CountryConfigurations from "../../../config/CountryConfigurations";
import { actionTypes } from "../../../utils/constants";
import { useStateValue } from "../../../store/StateProvider";
import Alert from "./Alert";
import AdobeAnalyticsButtonTags from "../../../constants/AdobeAnalyticsButtonTags";
import "./CountrySelectorIntl.scss";
import RegisterHeading from "../../RegisterHeading/RegisterHeading";
import InputRadio from "../Input/InputRadio";
import constants from "../../../config/constants";
import intlConstants from "../../../config/intlConstants";

const CountrySelectorIntl = ({ countryUser }) => {
  const [{ formValues }, dispatch] = useStateValue();
  const { t } = useTranslation();
  const [error, setError] = useState(false);
  const [countryOfSelling, setCountryOfSelling] = useState(null);

  const setCountryAndNavigate = () => {
    if (!countryOfSelling || (countryOfSelling === intlConstants.COLOMBIA_CODE && !formValues.isAPes)) {
      setError(true);
      return false;
    }

    dispatch({
      type: actionTypes.SET_COUNTRY,
      payload: countryUser
    });

    dispatch({
      type: actionTypes.SET_COUNTRY_OF_SELLING,
      payload: countryOfSelling
    });
  };

  const countryOnChangeHandler = countryCode => {
    setCountryOfSelling(countryCode);
    setError(false);
  };

  const getIsAPesField = () => {
    const facoPesFieldConfig = {
      containerClass: "",
      dataSource: "",
      default: "",
      id: constants.INPUT_ID_IS_A_PES,
      labelMandatory: "",
      label: "Are you identified as PES (Presencia Económica Significativa) in Colombia?",
      labelClass: "",
      labelDescription: "",
      name: constants.INPUT_ID_IS_A_PES,
      options: [
        {
          id: "isAPes_1",
          value: constants.SI,
          label: "Yes",
          labelClass: "rdb_label"
        },
        {
          id: "isAPes_2",
          value: constants.NO,
          label: "No",
          labelClass: "rdb_label"
        }
      ],
      placeHolder: "",
      required: true,
      validators: [
        {
          type: constants.VALIDATOR_NOT_EMPTY,
          errorMessage: "This field is mandatory."
        }
      ]
    };
    return <InputRadio fieldConfig={facoPesFieldConfig} key={facoPesFieldConfig.id} showErrors={error} />;
  };

  return (
    <Col lg={{ span: 6, offset: 1 }}>
      <Row>
        <Col>
          <RegisterHeading />
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="content_box shaded">
            <h1>{t("content.intlWhereSelling")}</h1>
            <Col xl={{ span: 6, offset: 3 }}>
              <label className="input_label_plain_country">{t("content.intlCountry")}</label>
              <ThumbnailDropdownControl
                fieldConfig={{ ...CountryConfigurations(countryOfSelling, true), class: " btn-country-select" }}
                fieldValue={""}
                key="contryCode"
                onChangeHandler={countryCode => countryOnChangeHandler(countryCode)}
              />
              {countryOfSelling == intlConstants.COLOMBIA_CODE && getIsAPesField()}
              {error && !countryOfSelling && (
                <Alert
                  text={t("country.selectCountryAndTypeOfPerson")}
                  color="var(--white)"
                  backgroundColor="var(--red)"
                />
              )}
            </Col>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="form_footer">
            <InputSubmit
              id={AdobeAnalyticsButtonTags[0].countrySelection}
              fieldConfig={{ name: "Submit", default: "buttons.next" }}
              onClick={setCountryAndNavigate}
            />
          </div>
        </Col>
      </Row>
    </Col>
  );
};

export default CountrySelectorIntl;
